import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {DEVOLVEREMPLEADOS, DEVOLVEREMPLEADOSSEMTIENDA} from '../queries/empleados.query';
import {
  ADDEMPLESEM, BUSQUEDAEMPLEADO, EMPLEADOTIENDA,
  GETDETALLEEMPLEADO,
  GETEMPLEADO,
  GETEMPLEADOSEMANA, GETEMPLEADOSEMANATIENDA,
  UPDATEEMPLESEM
} from '../../FriedmanModule/queries/empleado.semana.query';
import {EmpleadoSemanaModel} from '../../FriedmanModule/models/empleado.semana.model';

@Injectable()
export class EmpleadoServices {

  constructor(private apollo:Apollo){}

  devolverEmpleados(ids:string[]){
    return this.apollo.query<any>({
      query:DEVOLVEREMPLEADOS,
      variables:{
        ids:ids
      }

    });
  }

  devolverEmpleadosSemTienda(semana:string, tienda:string){
    return this.apollo.query<any>({
      query:DEVOLVEREMPLEADOSSEMTIENDA,
      variables:{
        semana:semana,
        tienda:tienda
      }

    });
  }

  devolverSemanaEmpleado(empleado:string, semana:string){
    return this.apollo.query<any>({
      query:GETEMPLEADOSEMANA,
      variables:{
        empleado:empleado,
        semana:semana
      }
    })
  }

  devolverSemanaEmpleadoTienda(empleado:string, semana:string, tienda:string){
    return this.apollo.query<any>({
      query:GETEMPLEADOSEMANATIENDA,
      variables:{
        empleado:empleado,
        semana:semana,
        tienda:tienda
      }
    })
  }

  addSemanaEmpleado(emHor:EmpleadoSemanaModel){

    return this.apollo.mutate<any>({
      mutation: ADDEMPLESEM,
      variables:{
        empleSem: JSON.stringify(emHor)
      }
    });

  }

  updateSemanaEmpleado(emHor:EmpleadoSemanaModel){

    return this.apollo.mutate<any>({
      mutation: UPDATEEMPLESEM,
      variables:{
        id: emHor.id,
        empleSem: JSON.stringify(emHor)
      }
    });
  }

  devolverVentaxEmpleado(empleado:string, tienda:string, semana:string, ano:string){

  }

  devolverSemanaTienda(empleado:string, semana:string){

  }

  devolverBusquedaEmpleado(idEmple:string, nombre:string, doc:string){
    return this.apollo.query<any>({
      query:BUSQUEDAEMPLEADO,
      variables:{
        id:idEmple,
        nombre:nombre,
        doc:doc
      }
    });
  }

  devolverEmpleado(empleado:string){
    return this.apollo.query<any>({
      query: GETEMPLEADO,
      variables:{
        id:empleado
      }
    })
  }

  devolverDetalleEmpleado(ano:number, numSem:number, tienda:any, empleado:string){
    return this.apollo.query<any>({
      query:GETDETALLEEMPLEADO,
      variables:{
        ano:ano,
        semana:numSem,
        ti:tienda,
        empleado:empleado,
        fecha:`${ano}-${numSem}`
      }
    })
  }

  devolverEmpleadoTienda(tienda:string){
    return this.apollo.query<any>({
      query:EMPLEADOTIENDA,
      variables:{
        tienda:tienda
      }
    })
  }



}
